import type { BlockTable } from '@dreamstack/payload/src/payload-types'
import includes from 'lodash/includes'
import type { FunctionComponent, ReactElement } from 'react'
import { TableDefault } from './TableDefault'
import { TableFinanceCalendar } from './TableFinanceCalendar'
import { TableGreyWhiteAlternating } from './TableGreyWhiteAlternating'

// Keys and possibleVariants must match contentful variant
const possibleVariants = ['Default', 'FinanceCalendar', 'GreyWhiteAlternating']

export type TableProps = {
  title: string
  variant: string
  table: ReactElement
}

const VariantMapping: Record<
  string,
  FunctionComponent<React.PropsWithChildren<{ block: BlockTable }>>
> = {
  Default: TableDefault,
  FinanceCalendar: TableFinanceCalendar,
  GreyWhiteAlternating: TableGreyWhiteAlternating,
}

export const Table: FunctionComponent<
  React.PropsWithChildren<{ block: BlockTable }>
> = ({ block }) => {
  const variant = block.variant
  const Component =
    !!variant && includes(possibleVariants, variant)
      ? VariantMapping[variant]
      : VariantMapping['Default']

  return <Component block={block} />
}
